import type { SacramentStatus } from 'generated/prisma/enums';
import type { ChoiceOption } from './fields';

export const SACRAMENT_OPTIONS: ChoiceOption<SacramentStatus>[] = [
  { value: 'BOTH', label: 'Ambos' },
  { value: 'ONLY_ONE', label: 'Somente um' },
  { value: 'NONE', label: 'Nenhum' },
];

export const MARRIED_OPTIONS: ChoiceOption<boolean>[] = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Ainda não' },
];

export const ACTIVE_OPTIONS: ChoiceOption<boolean>[] = [
  { value: true, label: 'Ativo' },
  { value: false, label: 'Inativo' },
];

/** "(19) 99999-9999" enquanto digita (aceita fixo com 10 dígitos). */
export const maskPhone = (v: string) => {
  const d = v.replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : '';
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

/** "00000-000" enquanto digita. */
export const maskCep = (v: string) => {
  const d = v.replace(/\D/g, '').slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
};
